var _defs, _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _path7, _path8, _path9, _polygon9, _polygon10, _path10, _path11, _path12, _polygon11, _polygon12, _path13, _path14, _path15, _ellipse2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _polygon13, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _polygon14, _polygon15, _polygon16, _polygon17, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _g, _path88, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _ellipse9, _path97, _polygon18, _polygon19, _polygon20, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _polygon21, _polygon22, _polygon23, _polygon24, _rect, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _rect2, _rect3, _rect4, _rect5, _rect6, _path135, _path136, _path137, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _rect7, _rect8, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriversettlements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "44ab1b28-df60-43dd-96f3-344df6392e15",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1091.78,
    height: 828.58,
    viewBox: "0 0 1091.78 828.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c6e87aad-8151-4bb2-867f-5915ddeef7a8",
    x1: 581.24,
    y1: 811.56,
    x2: 581.24,
    y2: 226.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "business deal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1132,274.72c-.19.89-.37,1.78-.58,2.66-6.56,30.25-17.28,59.4-33.22,86.17-.53.89-1.06,1.78-1.6,2.67a247.62,247.62,0,0,1-37.45,47.27c-7.94,7.84-16.6,15.29-26.9,20.66-14.43,7.54-31.3,10.6-47.88,13.1-17.22,2.61-34.68,4.79-52.09,7.14Q923,455.62,913.83,457c-16.82,2.49-33.52,5.37-49.82,9.19-20.15,4.71-39.68,10.88-58.13,19.56q-2.21,1-4.37,2.12c-1.44.72-2.89,1.45-4.31,2.19s-2.82,1.48-4.21,2.24c-.72.39-1.44.78-2.15,1.19s-1.41.77-2.1,1.17c-2.08,1.16-4.12,2.35-6.16,3.55l-.08.05c-1.35.79-2.68,1.6-4,2.41-7.54,4.58-14.92,9.36-22.3,14.17l-4.64,3-7.19,4.65c-1.4.91-2.83,1.82-4.24,2.72-1,.66-2,1.32-3.09,2-5.24,3.3-10.55,6.54-16,9.63-1.29.74-2.59,1.48-3.9,2.2a221.65,221.65,0,0,1-34.42,15.52l-.16.06a157,157,0,0,1-18.28,5.16c-3.57.78-7.15,1.42-10.77,1.91a115.46,115.46,0,0,1-29.2.41c-19.07-2.21-36.94-9.53-56-12-39.24-5-77.35,11.11-114.25,23.73q-13.61,4.65-27.42,8.71c-6.12,1.81-12.26,3.52-18.45,5.17A694.23,694.23,0,0,1,292.49,608a325.86,325.86,0,0,1-49.15,1.09c-6.23-.38-12.39-1-18.44-2-20.7-3.2-40-9.91-55.58-22.2-12.76-10.09-21.89-23.24-28.84-37a161.46,161.46,0,0,1-14.91-44.54c-.38-2.11-.72-4.23-1-6.35q-.75-5.44-1.12-10.94a156.59,156.59,0,0,1,6.88-57.85c6.6-20.92,17.6-41,22.44-62.08q.3-1.34.57-2.67a92.43,92.43,0,0,0,1.47-9.69c2.47-25.9-7-51.15-14.43-76.48-.26-.88-.52-1.77-.77-2.66q-1.2-4.22-2.3-8.43c-6.88-26.78-8.79-55.45-2.66-82.18.19-.89.42-1.78.64-2.66a120.32,120.32,0,0,1,22.62-46.33c11.48-14.4,26.55-26.39,42.65-36.92q11.77-7.7,24.34-14.39,9-4.8,18.44-9.09c50.45-23,108-34.23,164.91-31.75,3,.13,6,.29,9,.51s6.28.48,9.42.77C463.33,47.72,499,56.31,534.42,65.7c11.87,3.15,23.72,6.38,35.56,9.55,5.27,1.4,10.53,2.8,15.8,4.16,25.81,6.67,52,12.71,78.52,17.22q9.21,1.59,18.44,2.9A528.2,528.2,0,0,0,747.23,105q12.59.25,25.19-.22,6.36-.23,12.73-.69C829,101,871.38,90.66,913.83,81q9.21-2.1,18.45-4.14c8.08-1.78,16.16-3.5,24.28-5.09,50.53-9.93,95.57-4.22,142.55,16.27,10.68,4.65,21.35,10.27,27.89,19s8.18,19.45,9.4,29.8c1.73,14.74,2.86,29.67,3.29,44.68,0,.88,0,1.77.06,2.66C1140.43,214.5,1138.17,245.11,1132,274.72Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M796.82,363.55h-3.3v1.18l0,1.49h3.74Zm-37.43,0a.17.17,0,0,0,0,.07c-.09.73-.19,1.46-.29,2.2l0,.2,0,.2H787.7v-.16l2-2.51Zm-76.65,0V277.38h32.9c-.35-.23-.71-.47-1.08-.69l-.48-.31-.62-.38c-.36-.21-.72-.42-1.1-.62s-.61-.34-.93-.51l-.22-.12-.05,0H682.74V270l-.77.3-.81.38-.06,0-.17.09-.51.27-.51.27c-.5.27-1,.57-1.5.88l-.48.32-1,.64c-1.29.86-2.56,1.76-3.87,2.6-.33.21-.66.42-1,.61-.71.42-1.44.82-2.19,1.18-.32.16-.63.3-1,.43l-.54.21-.5.17h0a23.42,23.42,0,0,1-3.6.94v84.24H614.9c0,.1.07.18.1.28.27.8.54,1.59.8,2.39h48.5v92.36q.38,0,.75,0l.87.05,1.57.09L670,459l1.15.11,1.25.13h.19l2.21.27.47.06,1.07.15,1.53.22h0l3.67-.16h0l.5.09c.2,0,.41.06.62.1V366.22H759l0-.2,0-.2c.1-.74.2-1.47.29-2.2a.17.17,0,0,1,0-.07Zm114.08,0h-3.3v1.18l0,1.49h3.74Zm-39.49,0c-.12.89-.23,1.78-.35,2.67h31.89l2.17-2.67Zm-74.59,0V277.38h32.9c-.35-.23-.71-.47-1.08-.69l-.48-.31-.62-.38c-.36-.21-.72-.42-1.1-.62s-.61-.34-.93-.51l-.22-.12-.07,0h-28.4V270l-.77.3-.81.38-.06,0-.17.09-.51.27-.51.27c-.5.27-1,.57-1.5.88l-.48.32-1,.64c-1.29.86-2.56,1.76-3.87,2.6-.33.21-.66.42-1,.61-.71.42-1.44.82-2.19,1.18-.32.16-.63.3-1,.43l-.54.21-.5.17h0a23.42,23.42,0,0,1-3.6.94v84.24H614.9c0,.1.07.18.1.28.27.79.55,1.59.81,2.39H664.3v92.35l.75,0,.87.05,1.57.09L670,459l1.15.11,1.25.13h.19l2.21.27.47.06,1.07.15,1.53.22h0l3.67-.16h0l.5.09c.2,0,.41.06.62.1V366.22H757c.12-.89.23-1.78.35-2.67ZM932.28,184.11h207.47c0-.89,0-1.78-.06-2.66H932.28V76.83q-9.24,2-18.45,4.14V181.45H688.19l-.57-.51.86-.76h0l83.93-75.42q-12.6.48-25.19.22l-64.49,57.94V99.53q-9.24-1.31-18.44-2.9V160L570,75.25c-11.84-3.17-23.69-6.4-35.56-9.55L662.67,180.94l-.57.51H426.7V44.25q-4.71-.44-9.42-.77c-3-.22-6-.38-9-.51V181.45H243.34V74.72Q234,79,224.9,83.81v97.64H135.29c-.22.88-.45,1.77-.64,2.66H224.9v90.61H139.61c.25.89.51,1.78.77,2.66H224.9v86.17H153.34q-.27,1.33-.57,2.67H224.9V607.15c6,.93,12.21,1.58,18.44,2V366.22H408.25V587.75c6.19-1.65,12.33-3.36,18.45-5.17V366.22H664.3V559.77a157,157,0,0,0,18.28-5.16l.16-.06V366.22H913.83V457q9.2-1.35,18.45-2.59V366.22H1096.6c.54-.89,1.07-1.78,1.6-2.67H932.28V277.38h199.14c.21-.88.39-1.77.58-2.66H932.28Zm-688.94,0H408.25v90.61H243.34Zm0,179.44V277.38H408.25v86.17ZM426.7,184.11H664.3v90.61H426.7Zm0,179.44V277.38H664.3v86.17Zm487.13,0H682.74V277.38H913.83Zm0-88.83H682.74V186.54l3.24-2.43H913.83ZM759.39,363.55a.17.17,0,0,0,0,.07c-.09.73-.19,1.46-.29,2.2l0,.2,0,.2H787.7v-.16l2-2.51Zm37.43,0h-3.3v1.18l0,1.49h3.74Zm-114.08,0V277.38h32.9c-.35-.23-.71-.47-1.08-.69l-.48-.31-.62-.38c-.36-.21-.72-.42-1.1-.62s-.61-.34-.93-.51l-.22-.12-.05,0H682.74V270l-.77.3-.81.38-.06,0-.17.09-.51.27-.51.27c-.5.27-1,.57-1.5.88l-.48.32-1,.64c-1.29.86-2.56,1.76-3.87,2.6-.33.21-.66.42-1,.61-.71.42-1.44.82-2.19,1.18-.32.16-.63.3-1,.43l-.54.21-.5.17h0a23.42,23.42,0,0,1-3.6.94v84.24H614.9c0,.1.07.18.1.28.27.8.54,1.59.8,2.39h48.5v92.36q.38,0,.75,0l.87.05,1.57.09L670,459l1.15.11,1.25.13h.19l2.21.27.47.06,1.07.15,1.53.22h0l3.67-.16h0l.5.09c.2,0,.41.06.62.1V366.22H759l0-.2,0-.2c.1-.74.2-1.47.29-2.2a.17.17,0,0,1,0-.07Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M322.63,121.73h1.43a2.9,2.9,0,0,1-1.75-2.33h0c0-1.84,2.75-3.34,6.11-3.34h42.76c3.36,0,6.1,1.5,6.1,3.34h0c0,1.83-2.74,3.34-6.1,3.34h-1.43a2.87,2.87,0,0,1,1.75,2.32c0,1.57-2,2.89-4.67,3.24h12.31c3.35,0,6.1,1.5,6.1,3.34s-2.75,3.34-6.1,3.34H336.37c-3.35,0-6.1-1.51-6.1-3.34,0-1.57,2-2.88,4.67-3.24H322.63c-3.36,0-6.1-1.5-6.1-3.34S319.27,121.73,322.63,121.73Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M786.07,153.5h1.43a2.9,2.9,0,0,1-1.74-2.33h0c0-1.84,2.74-3.34,6.1-3.34h42.76c3.36,0,6.11,1.5,6.11,3.34h0c0,1.83-2.75,3.33-6.11,3.33H833.2a2.9,2.9,0,0,1,1.74,2.33c0,1.57-2,2.89-4.67,3.24h12.31c3.36,0,6.1,1.5,6.1,3.34s-2.74,3.34-6.1,3.34H799.82c-3.36,0-6.11-1.51-6.11-3.34,0-1.57,2-2.89,4.67-3.24H786.07c-3.35,0-6.1-1.5-6.1-3.34S782.72,153.5,786.07,153.5Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M257,289.46h1.42a2.89,2.89,0,0,1-1.74-2.33h0c0-1.83,2.75-3.34,6.1-3.34h42.77c3.35,0,6.1,1.51,6.1,3.34h0c0,1.84-2.75,3.34-6.1,3.34h-1.43a2.86,2.86,0,0,1,1.74,2.32c0,1.57-2,2.89-4.67,3.24h12.31c3.36,0,6.11,1.51,6.11,3.34s-2.75,3.34-6.11,3.34H270.78c-3.36,0-6.1-1.5-6.1-3.34,0-1.56,2-2.88,4.67-3.24H257c-3.36,0-6.11-1.5-6.11-3.34S253.68,289.46,257,289.46Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 852.65,
    cy: 602.96,
    rx: 64.96,
    ry: 213.77,
    transform: "translate(37.13 1281.96) rotate(-78.45)",
    fill: "#009ddd",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M828.56,420.59s11.37-55.81,54.78-50.64c0,0,30,2.06,36.17,21.7v43.41Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#3a3768"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1012.18 405.56 625.61 373.51 576 383.85 579.1 453.1 582.48 453.51 586.33 557.5 965.66 625.71 1005.98 591.6 1005.98 478.87 1011.14 475.84 1012.18 405.56",
    fill: "#d48a9b"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1012.7 405.56 1011.66 475.84 969.8 495.48 969.28 422.09 1012.7 405.56",
    opacity: 0.05
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "1005.98 478.94 1006.49 589.54 966.18 623.65 968.77 495.48 1005.98 478.94",
    opacity: 0.05
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "583 457.65 969.08 504.76 969.28 495.82 582.71 454.13 583 457.65",
    opacity: 0.05
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "1005.98 483 1005.98 478.94 967.73 495.82 967.73 504.78 1005.98 483",
    opacity: 0.05
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "575.48 383.85 625.09 373.51 1011.66 405.56 968.25 422.09 575.48 383.85",
    fill: "#efc6cd"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "970.48 407.55 989.45 408.79 958.01 418.2 942 417.05 970.48 407.55",
    opacity: 0.1
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "970.48 406.72 989.45 407.96 958.01 417.38 942 416.22 970.48 406.72",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.32,444.56c.75-.32,1.54.29,2.34.44.46.09.93,0,1.39.09.93.12,1.85.74,2.74.43",
    transform: "translate(-54.11 -35.71)",
    fill: "#d3dae1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.34,445.13c.74-.32,1.54.28,2.34.44.46.08.93,0,1.39.08.93.13,1.85.75,2.74.44",
    transform: "translate(-54.11 -35.71)",
    fill: "#d3dae1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.08,446.27c.75-.32,1.55.28,2.35.43.45.09.93,0,1.38.09.94.13,1.86.75,2.74.43",
    transform: "translate(-54.11 -35.71)",
    fill: "#d3dae1"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "888.48 398.21 907.45 399.46 876.01 408.87 860 407.71 888.48 398.21",
    opacity: 0.1
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "888.48 397.39 907.45 398.63 876.01 408.04 860 406.89 888.48 397.39",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M940.32,435.23c.75-.32,1.54.28,2.34.44.46.08.93,0,1.39.08.93.13,1.85.75,2.74.44",
    transform: "translate(-54.11 -35.71)",
    fill: "#d3dae1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M939.34,435.8c.74-.32,1.54.28,2.34.43.46.09.93,0,1.39.09.93.13,1.85.75,2.74.43",
    transform: "translate(-54.11 -35.71)",
    fill: "#d3dae1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M937.08,436.93c.75-.32,1.55.29,2.35.44.45.09.93,0,1.38.09.94.12,1.86.75,2.74.43",
    transform: "translate(-54.11 -35.71)",
    fill: "#d3dae1"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "927.81 402.88 946.79 404.12 915.35 413.54 899.33 412.38 927.81 402.88",
    opacity: 0.1
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "927.81 402.06 946.79 403.3 915.35 412.71 899.33 411.55 927.81 402.06",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M979.65,439.9c.75-.32,1.55.28,2.35.43.45.09.92,0,1.38.09.93.12,1.86.75,2.74.43",
    transform: "translate(-54.11 -35.71)",
    fill: "#d3dae1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M978.67,440.46c.75-.32,1.55.29,2.35.44.45.09.92,0,1.38.09.93.12,1.86.75,2.74.43",
    transform: "translate(-54.11 -35.71)",
    fill: "#d3dae1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M976.42,441.6c.74-.32,1.54.28,2.34.44.46.08.93,0,1.39.08.93.13,1.85.75,2.74.44",
    transform: "translate(-54.11 -35.71)",
    fill: "#d3dae1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 498.32,
    cy: 749.7,
    rx: 202.48,
    ry: 41.68,
    fill: "#009ddd",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M774.16,444.09C772,425.11,763.45,407,763.45,407l.65-6.4s.14-3.2-.07-8a36.4,36.4,0,0,1,1.17-8.88c1.75-5.55-2.19-12.37-2.63-13s.22-12.8-3.72-18.77-30.18-17.07-30.18-17.07-1.41-2.95-3.4-6.4l.18-.35a37.6,37.6,0,0,0-6-8.09c-1.61-1.72-3.16-2.7-4.41-2.22a36,36,0,0,1-1.16-5.07c.26.07.53.14.79.19a8.16,8.16,0,0,0,3.3.08c2.44-.55,4.06-2.74,5.42-4.8,6.78-10.3,12.62-21.6,13.81-33.79a21.48,21.48,0,0,0-.35-7.46,25.17,25.17,0,0,0-2.34-5.45,43.8,43.8,0,0,0-6.6-9.73c-4.67-4.92-11.11-7.93-17.73-9.71a61.38,61.38,0,0,0-22.9-1.71c-2,.23-4,.56-6,.69a62.32,62.32,0,0,1-7.61-.13l-13.09-.76-.06-.2-2.18-.13c-.86,1.71,0,3.74,1.07,5.34s2.3,3.27,2.21,5.16-1.46,3.41-2.53,5-1.88,3.67-.81,5.23a3,3,0,0,0,.53.58c1.13,1.17,3.1,1.3,4.81,1.28h.3a32.57,32.57,0,0,0-6.63,19.72,33.16,33.16,0,0,0,18.09,29.38c.19.65.38,1.32.56,2a61.26,61.26,0,0,1,2.1,21.62l-.23.5-.14-.53s-15.42,10.46-20,13.23-9.18,12.16-9.4,14.72-7.44,41.17-7.44,41.17a94.59,94.59,0,0,0-3.62,11.92L628,424.25s-19,1.71-24.5.43l.16,1.06a83.09,83.09,0,0,0-14.76-2,15.65,15.65,0,0,0-8,1.07l-.19.09-.15.07a31.7,31.7,0,0,0-8.4,2.36c-.32.13-.61.26-.89.39l.06-1.31-20.56-1.06-10.5-2.13s-3.72-3-5.91-2.56-6.78-2.56-6.78-2.56A18.33,18.33,0,0,0,524.2,416c-.35-2.42-.57-3.89-.57-3.89s-8.17-32.42-14.29-51.48c-4.1-12.73-10-19-13.48-21.73-1.55-2.7-2.57-4.44-2.57-4.44-.67-2.34-4.35-7.61-5.29-7.74-.15-.24-.26-.36-.32-.36a1.17,1.17,0,0,0-.59.09c-1.72-8.56-2.72-19.29-.09-28.64a31.61,31.61,0,0,0,11.54-24.36c0-.14,0-.28,0-.42s0-.29,0-.43a31.47,31.47,0,0,0-7.43-20.3l-.34-.38a2.65,2.65,0,0,0,.26-.21,5.36,5.36,0,0,0,1.89-5.16c-.45-1.92-1.95-3.43-2.72-5.25a34,34,0,0,1-1.11-4.28,13.2,13.2,0,0,0-3.15-5.49l.15.4c-3.92-4.41-10.66-6.6-16.73-5.62-4.51.72-8.71,2.82-13.24,3.47-3.25.46-6.56.16-9.83.49a25.51,25.51,0,0,0-8.72,2.52,5,5,0,0,0-1.85,1.36,7.32,7.32,0,0,0-.92,2.57c-1.11,4.05-4.63,6.94-7.18,10.32a24.15,24.15,0,0,0-4.84,13.34,10.44,10.44,0,0,0,.35,3.65c.22.71.56,1.38.72,2.1.5,2.2-.65,4.39-1.21,6.57a12.79,12.79,0,0,0,.71,8.34c3.95,8.84,16.92,11.79,19.62,21.07a25.81,25.81,0,0,0,6.49,2c.18.92.34,1.85.47,2.79a.75.75,0,0,0-.17.1c-3.5,3.41-4.37,10-4.37,10l-.42.34c-1.43,1.18-6.32,5.14-10.74,8.19-5.25,3.63-14,15.79-20.12,19.42s-11.16,26-9.84,34.13,6.78,30.93,4.59,39.25,3.28,46.29,3.28,46.29a55.91,55.91,0,0,1,10.72,3.18l-.11,1.66-.33,5s-9.91,35.84-6.12,63.43-1.75,30.43-1.75,30.43,1.16,12.23-1.75,16.5-3.5,13.65-3.5,13.65-.29,21.05.29,27,.87,16.79-1.17,19.35-5.83,19.33-5.54,24.45-7.29,16.79-3.21,31.86-12,15.36-12,15.36,2.05,23,6.42,29.58l.64.94c-.11.38-.22.78-.34,1.21-1.65,6-3.91,15.47-2.34,17.76,2.33,3.42,3.5,2.84,3.5,2.84l.87,15.36s17.5,14.79,30.92,14.23,10.79-14.23,10.79-14.23l-11.43-29.64-.39-1,12.7-24s3.5-10.52,4.37-14.22S449,698.51,449,698.51s12-28.44,12.25-31.86,1.17-21.89,3.5-25.6,8.75-25,8.75-25l.16.14a8.43,8.43,0,0,1,2.18,8.39c-1.47,5.4-.59,16.49-.59,16.49s-.58,9.39-1.75,14.23-1.45,44.37.59,53.75c1.63,7.51,1.58,21.57,1.5,26.89-1.37,5.65-2.57,12.67-.34,13.5,3.8,1.43,23.05,1.14,23.05,1.14s8.16-2.85,19.25,7.11,45.2-2.84,45.2-2.84,10.5-2.85-10.21-11.09c-14.45-5.75-23.78-9.58-29.88-13.68.14-.27.29-.54.42-.83,0,0-8.46-8-1.46-22.18s6.71-26.17,6.71-26.17l1.17-47.79L526,569.67l-2.71-66.58.48-.16c.46,12.24,2.85,41.38,15.36,35.73,15.75-7.11,2.33-25.6,2.33-25.6l-7.07-13.78,2.11-.72L528.59,473a57.65,57.65,0,0,1-.3-15.07,59.71,59.71,0,0,0-.18-8.8c10.36-1.81,20.28-3.73,22.06-3.29,2.1.51,13.85.61,18.47.63-1.51,1.18-2.72,2.35-2.72,2.35l18.81,12.66s6.38-3.49,7.71-7.19a8.3,8.3,0,0,0,3.52-1.88c.2,4.37,1.36,9.1,5.4,9.21a7,7,0,0,0,2.94-.58l30.76-6.09-2.64,16.49,1.84,3.27c-.93,13.91-2,28.68-2.94,41.67l-.43,2.84.22.05c-1.46,20-2.63,35.15-2.63,35.15a18.43,18.43,0,0,1,7.67-7.71l.2,29.68s1.54,46.93,1.54,53.33.21,20.69.21,20.69,3.29,17.49,5.25,23.25,3.5,32,3.5,32,4.6,7.25,2.63,10,7.66,8.74,7.66,8.74-6.13,8.32-6.57,13.87c-.05.64.58,1.32,1.72,2-.36.29-.73.58-1.14.86-2.84,1.9-7,3.22-13.26,2.68-17.07-1.5-29.1,14.29-18.6,17.49s42,3.84,42,3.84,9.54-5.95,17-3.27c-.11,6.26.2,12,.25,12.76l-.09.07c-4.46,4-13,10.88-21.34,13.69-12,4.05-14.66,20.48.87,22.61s38.28-2.56,38.28-2.56,11.81-8.74,20.78-10.66,16.63-6.19,15.1-11.31c-1-3.27-3.57-11.84-5.31-17.6q-.15-.52-.3-1c.27-.6.54-1.22.79-1.86,0,0-4.59-23.89-.87-29.86s1.75-65.71,1.75-65.71-6.35-15.14-3.06-24.31-5.25-22.19-5.25-22.19.93-26.09,3.43-40.63q.17-.93.33-1.8a81.92,81.92,0,0,0,12.2-4.71s2.19-32.86,3.5-40.32c.13-.7.31-1.83.53-3.3l1-5.27h0l1.18-6h0l4-20.45,7.22-9.34,18.6-19S776.35,463.08,774.16,444.09ZM487.32,326.76l-.14.1a1.74,1.74,0,0,1-.05-.22A.9.9,0,0,0,487.32,326.76Zm183.77,23.29-.72,1.57L673,349l-3.57,4,1.2-2.52Zm-17.76,36.7c-.69,1.83-1.43,3.81-2.2,5.87l1.41-4.21Z",
    transform: "translate(-54.11 -35.71)",
    fill: "url(#c6e87aad-8151-4bb2-867f-5915ddeef7a8)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M595.94,446.58s-2.45,16.31,4.9,16.52,12.26-12.58,12.26-12.58l-3-10.23Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#585b8a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M595.94,446.58s-2.45,16.31,4.9,16.52,12.26-12.58,12.26-12.58l-3-10.23Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M431.31,799.62c-13.08.57-30.14-14.21-30.14-14.21l-.85-15.35s-1.13.57-3.41-2.84c-1.53-2.29.67-11.78,2.28-17.75.78-2.92,1.42-5,1.42-5l28.7,7.68,1.37,3.63,11.14,29.62S444.38,799.05,431.31,799.62Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#636992"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M563.18,756.14s-33.25,12.79-44,2.84-18.76-7.11-18.76-7.11-18.76.29-22.46-1.14c-2.18-.83-1-7.94.36-13.6.92-3.91,1.92-7.14,1.92-7.14s32.68-11.09,37.8-4.27a24.51,24.51,0,0,0,5.45,5.2c5.92,4.28,15.17,8.16,29.8,14.13C573.41,753.29,563.18,756.14,563.18,756.14Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#636992"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M533.34,496.35l9.09,18.19s13.08,18.48-2.27,25.58S525.1,499.2,525.1,499.2Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#ffd6d6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M495.25,338.61s9.95,4.55,15.92,23.59,13.93,51.45,13.93,51.45,5.4,36.66,4.54,45.76a59,59,0,0,0,.29,15.06l7.67,25.58-15.35,5.4-23.59-90.38Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#dce6f2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M495.25,338.61s9.95,4.55,15.92,23.59,13.93,51.45,13.93,51.45,5.4,36.66,4.54,45.76a59,59,0,0,0,.29,15.06l7.67,25.58-15.35,5.4-23.59-90.38Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.05
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M429.31,752.16l1.37,3.63L429,759c-6.54,2.84-22.74.57-22.74.57s-3-3.81-7.1-10.08c.78-2.92,1.42-5,1.42-5Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M524.53,732.26c-8.29,18.78-36.47,11.81-44.3,9.46-1.29-.39-2-.65-2-.65s.05-1.53.07-3.94c.92-3.91,1.92-7.14,1.92-7.14s32.68-11.09,37.8-4.27a24.51,24.51,0,0,0,5.45,5.2A9.64,9.64,0,0,0,524.53,732.26Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M523.1,708.39c-6.82,14.2,1.43,22.17,1.43,22.17-8.29,18.77-36.47,11.81-44.3,9.45-1.29-.38-2-.64-2-.64s.57-19.62-1.42-29-1.71-48.88-.57-53.71,1.7-14.22,1.7-14.22-.85-11.08.57-16.48a8.51,8.51,0,0,0-2.12-8.38l-.15-.15s-6.25,21.32-8.53,25-3.12,22.17-3.41,25.58-11.94,31.84-11.94,31.84-4.54,13.07-5.39,16.76-4.27,14.22-4.27,14.22L429,757.27c-6.54,2.84-22.74.57-22.74.57s-3.12-4-7.39-10.52-6.25-29.55-6.25-29.55,15.63-.29,11.65-15.35,3.41-26.72,3.13-31.84,3.41-21.88,5.4-24.44,1.7-13.36,1.13-19.33-.28-27-.28-27,.57-9.38,3.41-13.64,1.71-16.49,1.71-16.49,5.39-2.84,1.7-30.41,6-63.38,6-63.38l.33-5,.52-8.1s81.29-5.12,87.83,1.13a21.56,21.56,0,0,1,4.15,5.95A59.2,59.2,0,0,1,524,485l3.41,86.12,3.41,63.38-1.14,47.75S529.93,694.17,523.1,708.39Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#565988"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M499,538.42l-8.53,184.74L480.23,740c-1.29-.38-2-.64-2-.64s.57-19.62-1.42-29-1.71-48.88-.57-53.71,1.7-14.22,1.7-14.22-.85-11.08.57-16.48a8.51,8.51,0,0,0-2.12-8.38l.14-1Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M407.14,736.81s22.17-8.81,25.58-6-26.14,7.1-26.14,7.1Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M516.57,713.5c-.85.29-22.45,8-20.46,16.2S516.57,713.5,516.57,713.5Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M449.07,293s7.24,17.48,3.41,26.44,41.35,24.3,41.35,24.3-13.21-34.11-.42-53.3S449.07,293,449.07,293Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#ffd6d6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M713.61,799.05c-8.74,1.92-20.25,10.66-20.25,10.66s-22.17,4.69-37.31,2.56-12.57-18.55-.85-22.6c8.13-2.8,16.46-9.71,20.81-13.67,1.92-1.77,3.06-3,3.06-3l42.43-8.53s.69,2.37,1.65,5.64c1.7,5.77,4.21,14.33,5.17,17.59C729.81,792.87,722.35,797.13,713.61,799.05Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#505484"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M702.74,766.22s-17.91,1.92-25.37-2.34-18.12,2.56-18.12,2.56-30.7-.64-40.93-3.84,1.49-19,18.12-17.48c6.06.55,10.16-.78,12.93-2.68A13.62,13.62,0,0,0,655,734l36,2.13,5,12.76Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#505484"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M696.55,754.71s-41.84-6.84-47.18-12.27A13.62,13.62,0,0,0,655,734l36,2.13,5,12.76Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M634.52,515.33l.43,62.45s1.49,46.9,1.49,53.3.21,20.67.21,20.67,3.2,17.48,5.12,23.24,3.41,32,3.41,32,4.48,7.25,2.56,10,7.46,8.74,7.46,8.74-6,8.32-6.39,13.86S696.55,753,696.55,753L677.8,560.73l-14.93-48.17Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#575988"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M634.52,515.33l.43,62.45s1.49,46.9,1.49,53.3.21,20.67.21,20.67,3.2,17.48,5.12,23.24,3.41,32,3.41,32,4.48,7.25,2.56,10,7.46,8.74,7.46,8.74-6,8.32-6.39,13.86S696.55,753,696.55,753L677.8,560.73l-14.93-48.17Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M723.15,770.16c-13.93,33.21-47.06,7.58-47.06,7.58s0-.64-.08-1.74c1.92-1.77,3.06-3,3.06-3l42.43-8.53S722.19,766.89,723.15,770.16Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M723.63,767.29c-13.65,35-47.54,8.74-47.54,8.74s-1.07-18.12,1.07-26.43-2.35-33.26-2.35-33.26-2.56-22.17-4.9-27.28-2.13-15.35-2.13-16.2.85-7.68-1.07-12.37-3-16.2-3-16.2,0-16.2-1.92-25.79l-6.61-33-11.94-67.58,3.73-.64,66.83-11.72s12.58,64,8.31,70.56c-.92,1.44-1.73,4.59-2.4,8.65-2.44,14.52-3.35,40.59-3.35,40.59s8.31,13,5.12,22.17,3,24.3,3,24.3,1.92,59.69-1.71,65.66S723.63,767.29,723.63,767.29Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#575988"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M717.23,330.94s-60.54,42.63-46.9,21.31c7.35-11.48,6-26.1,3.12-37.14a87.64,87.64,0,0,0-6-16.29s51.44-21.88,44.62-2.27a36.74,36.74,0,0,0-2,14.24A38,38,0,0,0,717.23,330.94Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#d28690"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M608.23,428.57s-25.58-7.39-29.84-.14,1.28,23.16,9,25.72,25.44-8.67,25.44-8.67Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#d28690"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M637.51,416l-10.66,9.81s-18.55,1.7-23.88.42c0,0,4.91,32.83-2.13,36.88l43.06-8.74Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#585b8a"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M637.51,416l-10.66,9.81s-18.55,1.7-23.88.42c0,0,4.91,32.83-2.13,36.88l43.06-8.74Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M500.65,275.09a32,32,0,0,1-32,32c-16.42-7.89-32-14.31-32-32a32,32,0,1,1,63.95,0Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M500.65,274.23A31.94,31.94,0,1,1,493.41,254,32,32,0,0,1,500.65,274.23Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#ffd6d6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M519.3,469.9a72.32,72.32,0,0,1-9.91,5.14s-16.2-2.35-18.54.42-23,3.84-23,3.84-31.55-1.49-36.24-5.54a19.2,19.2,0,0,0-4.79-2.84l.52-8.1s81.29-5.12,87.83,1.13A21.56,21.56,0,0,1,519.3,469.9Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M523.25,464.17c-.64,3.62-13.86,9.16-13.86,9.16s-16.2-2.34-18.54.43-23,3.84-23,3.84-31.55-1.5-36.24-5.55-15.14-6-15.14-6-5.33-37.94-3.19-46.25-3.2-31.13-4.48-39.23,3.62-30.48,9.59-34.1,14.5-15.78,19.61-19.4c4.31-3.05,9.07-7,10.46-8.19l.41-.34s.86-6.61,4.27-10,34.74,21.53,34.74,21.53.22,1.92,2.35-1.7c.48-.81,4.61,5.15,5.33,7.67,0,0,17.05,29.85,18.12,36s5.54,26.22,6.39,31.12c.22,1.26.58,5.68,1,11.6.08,1.16.15,2.39.24,3.67.63,9.82,1.31,22.36,1.72,31.84,0,1.08.09,2.12.12,3.12A106.15,106.15,0,0,1,523.25,464.17Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#dce6f2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M415,387.21s11.72,14.28,15.56,14.28S415,387.21,415,387.21Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M439.69,417.91s-19.19,20.89-16.63,24.73S439.69,417.91,439.69,417.91Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M425.62,459.48s22-24.09,23-32.4Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M453.33,461.18s25.37-13.43,27.5-24.09S453.33,461.18,453.33,461.18Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M485.52,331.58,482,340.1l5.86,2.77,5.76,16.1s15.88,31.76,15.24,48.28,2.88,41.35,2.88,41.35l9.16-1.7-4.32-48.59A70.09,70.09,0,0,0,511,376.5c-7.32-16.76-20.94-47.7-21.8-47.7-1.17,0-.35.43-.35.43Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M486.37,330.72l-3.52,8.53,5.87,2.77,5.75,16.1s15.88,31.76,15.24,48.28,2.88,41.35,2.88,41.35l9.17-1.7-4.33-48.59a69.82,69.82,0,0,0-5.57-21.81c-7.32-16.77-20.94-47.7-21.79-47.7-1.18,0-.36.43-.36.43Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#575989"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M590.18,456c-4.46-.34-15.16-5.75-19.41-8l-1.8-1,.22-16.51a29,29,0,0,1,3.26-1.65c5.68-2.48,17.33-5.85,23.17,5C603.5,448.39,595.83,456.38,590.18,456Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#ffd6d6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M493.41,254a4.73,4.73,0,0,1-1.49.61c-3.71.81-7.93-2.38-11.11-.33-1.94,1.26-2.39,3.87-2.65,6.17q-.68,6-1.36,11.92a14.71,14.71,0,0,1-.88,4.11c-1.57,3.59-5.88,5.28-9.81,5.22a5.85,5.85,0,0,1-4.23-1.4c-.69-.7-1.06-1.68-1.82-2.32-5-4.19-6.52,6.08-5.2,9,2.12,4.77,9.65,9.37,6.49,15.43a5.78,5.78,0,0,1-2.32,2.33A32,32,0,1,1,493.41,254Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M459.21,277.94c.75.63,1.13,1.61,1.82,2.31a5.86,5.86,0,0,0,4.23,1.4c3.93.06,8.24-1.62,9.8-5.23a14.24,14.24,0,0,0,.89-4.1l1.36-11.92c.26-2.3.7-4.91,2.65-6.17,3.18-2,7.4,1.14,11.11.33a5.43,5.43,0,0,0,4-6.26c-.43-1.91-1.89-3.42-2.64-5.24a34.24,34.24,0,0,1-1.09-4.27c-2.07-7.76-11.18-12.12-19.1-10.82-4.4.73-8.49,2.83-12.9,3.47-3.16.46-6.39.16-9.58.5a24.18,24.18,0,0,0-8.5,2.51,4.94,4.94,0,0,0-1.8,1.36,7.51,7.51,0,0,0-.9,2.56c-1.07,4-4.51,6.95-7,10.32A24.59,24.59,0,0,0,426.82,262a10.67,10.67,0,0,0,.34,3.65c.21.7.54,1.38.7,2.1.49,2.19-.63,4.38-1.18,6.56a13.12,13.12,0,0,0,.7,8.34c3.84,8.83,16.49,11.78,19.12,21.05a21,21,0,0,0,7.44,2c2.58.05,5.36-1.06,6.56-3.35,3.15-6-4.37-10.66-6.49-15.42C452.68,284,454.17,273.74,459.21,277.94Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#353045"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M712.12,296.55a36.74,36.74,0,0,0-2,14.24c-1.54,1.31-3.22-2.61-5-1.6-4.88,2.82-10.52,9.53-16.56,9.53a33.17,33.17,0,0,1-15.07-3.61,87.64,87.64,0,0,0-6-16.29S718.94,276.94,712.12,296.55Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M721.78,283.76a33.26,33.26,0,1,1-33.26-33.26A33.25,33.25,0,0,1,721.78,283.76Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#d28690"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M720.36,338.33s-6.26,6.82-7.11,7.38-19,77-19.32,77.89-21.61,69.91-21.61,69.91l-34.11,16.77,2.85-84.42,25-69.62s8.25-9.38,10.8-12.79,34.39-23.88,34.39-23.88l5.44,11.21Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#f0f3f7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M715.85,332.49l-39.22,28.08L676,345.15c2.56-3.41,34.39-23.87,34.39-23.87Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M716.7,330.78l-39.22,28.08-.61-15.41c2.56-3.42,34.39-23.88,34.39-23.88Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#f0f3f7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M675.56,336.59l1.31,6.86-8.77,8.91,7-15.67s-15,10.45-19.5,13.22-9,12.15-9.17,14.71-7.25,41.14-7.25,41.14-5.33,14.28-3.83,18.33-8.1,131.74-8.1,131.74A19,19,0,0,1,640.07,546l-3.42-75.46s4.16-50.2,4.37-50.84,9.7-29.74,9.7-29.74Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#585b8a"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M677.73,344.3l-.68,14s-9.49,29.95-12.68,34.85-12.9,34.11-12.9,34.11L646,478l-9.38,4.27L632,473.76l7.68-49s14.49-41.35,16.63-45.62L667,356.62Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M676.87,343.45l-.67,14s-9.49,29.95-12.69,34.85-12.89,34.11-12.89,34.11l-5.44,50.73-9.38,4.26-4.69-8.52,7.68-49s14.49-41.36,16.62-45.62l10.77-22.49Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#663d5c"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M566.31,450.31,584.64,463s12.93-7.25,5.4-11.94-14.21-5.4-16.63-5.4S566.31,450.31,566.31,450.31Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#d28690"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M580,426.85a2.82,2.82,0,0,0-1.33,2.41c0,3.89.44,14.19,3.7,9.54,4-5.69,3.27-10.8,9.38-7.11a36,36,0,0,1,9.8,9l-1.7-12.22S587.29,422.27,580,426.85Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#d28690"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M722.13,576.08c-.92,1.44-1.73,4.59-2.4,8.65C682.35,595.94,655,572.24,655,572.24a326.27,326.27,0,0,1-8.1-34.1c-.67-3.94-.52-11.58.1-20.9l66.83-11.72S726.4,569.47,722.13,576.08Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M760.5,385.29c-1.7,5.55-1.06,16.84-1.06,16.84l-15.35,72.48s-7.46,55.85-8.74,63.31-3.41,40.29-3.41,40.29c-43.49,21.32-77-7.67-77-7.67a326.8,326.8,0,0,1-8.1-34.11c-2.14-12.66,4.16-63.38,7.14-85.91.89-6.67,1.49-10.87,1.49-10.87l11.19-41.57s13.75-35.07,18.87-45.3,25.68-33.21,25.68-33.21c2.55-1.62,6.63,4.1,9.66,9.31,2.29,3.94,4,7.6,4,7.6s25.58,11.08,29.41,17,3.2,18.12,3.63,18.76S762.21,379.75,760.5,385.29Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#585b8a"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M700.18,359.5s1.92,11.3-3,14.71c-4.75,3.3-40.11,72.83-42.31,77.17.89-6.68,1.49-10.88,1.49-10.88l11.19-41.56s13.76-35.07,18.87-45.31,25.69-33.21,25.69-33.21c2.55-1.62,6.62,4.1,9.65,9.31C717.19,339.22,707.66,357.16,700.18,359.5Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M699.33,358.65s1.91,11.3-3,14.71S656.23,446.18,654,450.52c.89-6.67,1.49-10.87,1.49-10.87l11.19-41.57s13.75-35.07,18.87-45.3,25.68-33.21,25.68-33.21c2.55-1.62,6.63,4.1,9.66,9.31C716.34,338.36,706.8,356.31,699.33,358.65Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#585b8a"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "695.95 425.05 683.92 487.64 683.92 487.65 682.77 493.64 682.77 493.65 680.18 507.12 669.13 504.78 663.98 503.69 592.71 488.59 587.47 487.48 575.51 484.95 577.85 469.41 578.82 462.95 587.45 405.65 695.95 425.05",
    fill: "#009ddd"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M683.55,511.92s-28.35,10.23-22.17,22.38,45.83-9.38,45.83-9.38Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#d28690"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M703.8,599.1c0,.85,1.07,11.73,5.33,15.56S703.8,599.1,703.8,599.1Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M675.24,637.68s5.11,14.07,25.36,19.83S675.24,637.68,675.24,637.68Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M721.78,283.76a33.25,33.25,0,0,1-16.67,28.83,17.7,17.7,0,0,1-5-4.17c-1.45-1.76-2.58-4.16-1.71-6.26.7-1.69,2.55-2.76,3-4.51a6.64,6.64,0,0,0-.16-3.22c-.37-1.65-.72-3.3-1.08-4.94-.31-1.4-.86-3.05-2.25-3.39s-2.55.82-3.64,1.68c-2.67,2.11-7.79,3.54-11,1.81s-2.31-7.52-2.83-10.65a1.86,1.86,0,0,0-.7-1.41,2.92,2.92,0,0,0-1.45-.1c-1.73,0-3.12-1.55-3.62-3.21a27.63,27.63,0,0,1-.58-5.15c-.19-1.73-.82-3.56-2.3-4.45A7.11,7.11,0,0,0,668,264l-6.27.07a33.26,33.26,0,0,1,60,19.72Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M695.16,287.78c1.09-.86,2.29-2,3.64-1.67s1.93,2,2.24,3.38l1.08,4.93a6.7,6.7,0,0,1,.17,3.23c-.51,1.76-2.35,2.82-3.06,4.51-.87,2.1.27,4.5,1.71,6.25a18,18,0,0,0,10.29,6.15,7.56,7.56,0,0,0,3.21.07c2.38-.55,4-2.74,5.28-4.79,6.61-10.3,12.3-21.59,13.46-33.77a21.66,21.66,0,0,0-.34-7.45,25,25,0,0,0-2.28-5.45,44,44,0,0,0-6.43-9.73c-4.55-4.9-10.83-7.91-17.28-9.69A58.52,58.52,0,0,0,684.54,242c-2,.23-3.92.56-5.89.69a59.28,59.28,0,0,1-7.42-.12l-14.72-.88c-.84,1.71,0,3.74,1,5.34s2.24,3.26,2.16,5.16-1.43,3.4-2.47,5-1.83,3.67-.79,5.23,3.16,1.66,5,1.64l7.42-.08a7.09,7.09,0,0,1,3.77.65c1.48.89,2.11,2.73,2.3,4.45a29.43,29.43,0,0,0,.58,5.15c.51,1.66,1.89,3.23,3.62,3.21a2.7,2.7,0,0,1,1.45.11,1.84,1.84,0,0,1,.7,1.4c.52,3.13-.44,8.91,2.83,10.65S692.49,289.89,695.16,287.78Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#663d5c"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M737.43,353.47a16.3,16.3,0,0,0-17.15,10.95c-4,11.39-10.67,31.94-9,40.06,2.35,11.51,5.12,30.7,5.12,30.7s12.15,7,6,14.06-7.89,17.06-7.89,17.06-7.89,3.41-9.59,10.66-13.22,17.26-13.22,17.26l-17.26,17.27s28.56,29,34.32,30.48l17.69-20.68,20.89-27.71,18.12-19s4.26-10,2.13-29-10.45-37.09-10.45-37.09l.64-6.4S759.74,356.24,737.43,353.47Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M739.13,353.47A16.3,16.3,0,0,0,722,364.42c-4,11.39-10.67,31.94-9,40.06,2.34,11.51,5.11,30.7,5.11,30.7s12.15,7,6,14.06-7.88,17.06-7.88,17.06-7.89,3.41-9.6,10.66-13.21,17.26-13.21,17.26l-17.27,17.27s28.56,29,34.32,30.48l17.69-20.68L749,493.58l18.12-19s4.27-10,2.13-29-10.44-37.09-10.44-37.09l.64-6.4S761.44,356.24,739.13,353.47Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#585b8a"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M721.28,418.34s18.12,22.16,25.8,17.26S721.28,418.34,721.28,418.34Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M728.1,401.28c1.92.64,17.7,22.6,25.8,20S728.1,401.28,728.1,401.28Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M732.58,439s1.07,12.58,14.07,10.87S732.58,439,732.58,439Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "621.02 301.83 613.99 317.5 622.77 308.59 621.02 301.83",
    opacity: 0.1
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "621.02 300.98 613.99 316.65 622.77 307.74 621.02 300.98",
    fill: "#f0f3f7"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "592.71 488.59 587.47 487.48 577.85 469.41 578.82 462.95 592.71 488.59",
    opacity: 0.3
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "683.92 487.65 682.77 493.64 682.77 493.65 669.13 504.78 663.98 503.69 683.92 487.65",
    opacity: 0.3
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M523.12,453.43c-2.64.44-5.2.84-7.54,1.14-13,1.71-43.92-13.64-43.92-13.64s-37.73-31.55-48.6-61.39,13-34.32,13-34.32c9-5.12,28.57,9.16,31.34,11.51s5.12,8.31,4.9,12.15,6.4,8.74,6.4,8.74,11.3,19.61,14.07,21.74,3.41,4.05,4.26,7.68,8.31,6.61,11.51,6.39,7,1.07,7,2.77c0,1.37,3.13,2.05,5.7,2.27C522,429.4,522.75,443.72,523.12,453.43Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M523,450.31c-2,.32-3.92.61-5.72.85-13,1.71-43.91-13.64-43.91-13.64s-37.73-31.55-48.6-61.39,13-34.32,13-34.32c9-5.12,28.56,9.16,31.33,11.51s5.12,8.31,4.91,12.15,6.39,8.74,6.39,8.74,11.3,19.61,14.07,21.74,3.41,4.05,4.27,7.68,8.31,6.6,11.51,6.39,7,1.07,7,2.77c0,1,1.78,1.67,3.76,2,.08,1.16.15,2.39.24,3.67C521.91,428.29,522.59,440.83,523,450.31Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M572.45,428.84,571.64,448h-.87l-1.8-1,.22-16.51A29,29,0,0,1,572.45,428.84Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M436.06,343.51s-23.87,4.48-13,34.32,48.6,61.4,48.6,61.4,30.91,15.34,43.92,13.64,32.82-6.18,35.38-5.54,19.83.64,19.83.64l.85-20-20-1.07-10.23-2.13s-3.63-3-5.76-2.56-6.6-2.56-6.6-2.56-3.42-2.77-6-2.77-7.46-.64-7.46-2.34-3.84-3-7-2.77S497.88,409,497,405.33s-1.49-5.54-4.26-7.67-14.07-21.75-14.07-21.75-6.61-4.9-6.4-8.73-2.13-9.81-4.9-12.16S445,338.4,436.06,343.51Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#dce6f2"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M497.46,412.15s-9.17,9.17-6.83,10.87Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M507.26,419.4s-11.94,9.17-8.74,9.81S507.26,419.4,507.26,419.4Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M487,433c1.71.86,27.07,16,36.67,15.78Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M488.72,331.79s-4.48,14.71-6.19,14.71c-1.34,0-23.84-18.22-33.23-25.88l.41-.34s.85-6.61,4.26-10S488.72,331.79,488.72,331.79Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M487.86,330.08s-4.47,14.71-6.18,14.71c-1.35,0-23.85-18.22-33.24-25.88l.41-.34s.86-6.61,4.27-10S487.86,330.08,487.86,330.08Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#dce6f2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.49,282.54v0c3,6.85,11.26,10.17,16.05,15.63C440.69,291.46,432.36,288.17,427.49,282.54Z",
    transform: "translate(-54.11 -35.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.06,298.32c-1.19,2.29-4,3.4-6.56,3.35a19.14,19.14,0,0,1-6.58-1.68,12.79,12.79,0,0,1,1.7,3.62,20.9,20.9,0,0,0,7.44,2c2.59.06,5.37-1.05,6.56-3.35,1.91-3.65-.08-6.77-2.41-9.72A6.35,6.35,0,0,1,458.06,298.32Z",
    transform: "translate(-54.11 -35.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.17,248.2c-.43-1.92-1.89-3.43-2.64-5.24a32.72,32.72,0,0,1-1.09-4.28,13.26,13.26,0,0,0-3.07-5.49,12.76,12.76,0,0,1,.51,1.51A34.39,34.39,0,0,0,490,239c.75,1.81,2.21,3.32,2.64,5.24a5.43,5.43,0,0,1-4,6.26c-3.7.81-7.92-2.39-11.1-.33-1.95,1.25-2.4,3.86-2.66,6.16q-.67,6-1.36,11.93a14.3,14.3,0,0,1-.88,4.1c-1.57,3.6-5.88,5.29-9.81,5.23a5.89,5.89,0,0,1-4.22-1.4,27.87,27.87,0,0,0-1.83-2.32c-5-4.2-6.52,6.07-5.2,9a18.12,18.12,0,0,0,2.44,3.67c-1.1-3.3.44-12.8,5.32-8.73a25.82,25.82,0,0,1,1.82,2.32,5.93,5.93,0,0,0,4.23,1.4c3.93.06,8.24-1.63,9.81-5.23a14.3,14.3,0,0,0,.88-4.11q.68-6,1.36-11.92c.26-2.3.71-4.91,2.65-6.16,3.19-2.06,7.41,1.14,11.11.32A5.42,5.42,0,0,0,495.17,248.2Z",
    transform: "translate(-54.11 -35.71)"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M716.57,312.08a7.73,7.73,0,0,1-3.21-.08,18,18,0,0,1-10.28-6.14c-1.45-1.76-2.59-4.16-1.71-6.26.7-1.69,2.54-2.75,3-4.51a6.7,6.7,0,0,0-.17-3.23l-1.08-4.93c-.31-1.4-.85-3.05-2.24-3.38s-2.55.81-3.64,1.67c-2.67,2.11-7.8,3.55-11,1.81s-2.31-7.52-2.83-10.65a1.87,1.87,0,0,0-.7-1.4,2.85,2.85,0,0,0-1.46-.11c-1.73,0-3.11-1.55-3.62-3.21a28.39,28.39,0,0,1-.57-5.15c-.2-1.72-.82-3.56-2.31-4.45a7.19,7.19,0,0,0-3.77-.65l-7.42.08c-1.83,0-4-.12-5-1.64s-.26-3.68.79-5.23,2.38-3.09,2.47-5-1.15-3.56-2.16-5.16a9.25,9.25,0,0,1-1.26-2.86l-2.13-.13c-.83,1.7,0,3.73,1,5.34s2.25,3.26,2.16,5.15-1.42,3.41-2.47,5-1.82,3.67-.78,5.23,3.15,1.67,5,1.65l7.42-.09a7.18,7.18,0,0,1,3.77.66c1.49.89,2.12,2.73,2.31,4.45a27.63,27.63,0,0,0,.58,5.15c.5,1.65,1.89,3.23,3.62,3.2a2.93,2.93,0,0,1,1.45.11,1.88,1.88,0,0,1,.7,1.41c.52,3.12-.44,8.91,2.83,10.65s8.37.3,11-1.81c1.09-.86,2.3-2,3.65-1.68s1.93,2,2.23,3.38l1.09,4.94a6.69,6.69,0,0,1,.16,3.23c-.5,1.75-2.35,2.82-3.05,4.5-.87,2.1.26,4.51,1.71,6.26A18,18,0,0,0,711,314.34a7.73,7.73,0,0,0,3.21.08,7.54,7.54,0,0,0,4.16-3.16A5.56,5.56,0,0,1,716.57,312.08Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.69,
    cy: 714.3,
    rx: 24.17,
    ry: 3.71,
    fill: "#009ddd",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1047.61,
    cy: 617.84,
    rx: 24.17,
    ry: 3.71,
    fill: "#009ddd",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 801.2,
    cy: 767.34,
    rx: 70,
    ry: 10.74,
    fill: "#009ddd",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1000.19,
    cy: 721.84,
    rx: 54.6,
    ry: 8.38,
    fill: "#009ddd",
    opacity: 0.1
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 991.2,
    cy: 805.34,
    rx: 92.59,
    ry: 14.21,
    fill: "#009ddd",
    opacity: 0.1
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.24,
    cy: 817.84,
    rx: 70,
    ry: 10.74,
    fill: "#009ddd",
    opacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M258.9,631.85s2.74,3.58-1.26,9-7.3,10-6,13.34c0,0,6-10,11-10.18S264.31,637.89,258.9,631.85Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M258.9,631.85a4,4,0,0,1,.56,1.12c4.8,5.64,7.35,10.89,2.74,11-4.29.12-9.44,7.8-10.67,9.74a3.73,3.73,0,0,0,.14.44s6-10,11-10.18S264.31,637.89,258.9,631.85Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M264,636.41c0,1.26-.15,2.28-.32,2.28s-.32-1-.32-2.28.18-.66.35-.66S264,635.15,264,636.41Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#ffd037"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M265.74,637.92c-1.1.6-2.07,1-2.15.81s.74-.76,1.85-1.37.67-.16.75,0S266.85,637.31,265.74,637.92Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#ffd037"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M244.44,631.85s-2.74,3.58,1.26,9,7.31,10,6,13.34c0,0-6-10-10.95-10.18S239,637.89,244.44,631.85Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M244.44,631.85a4.41,4.41,0,0,0-.56,1.12c-4.8,5.64-7.35,10.89-2.74,11,4.29.12,9.44,7.8,10.68,9.74a3.81,3.81,0,0,1-.15.44s-6-10-10.95-10.18S239,637.89,244.44,631.85Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M239.35,636.41c0,1.26.14,2.28.31,2.28s.32-1,.32-2.28-.18-.66-.35-.66S239.35,635.15,239.35,636.41Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#ffd037"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M237.6,637.92c1.11.6,2.07,1,2.16.81s-.75-.76-1.86-1.37-.67-.16-.75,0S236.49,637.31,237.6,637.92Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#ffd037"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.56,
    cy: 641.47,
    rx: 28.63,
    ry: 4.39,
    fill: "#009ddd",
    opacity: 0.1
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M266.41,649.35l-.14,1.12-.19,1.58-.08.66-.19,1.58-.09.66-.19,1.58-2.19,18c-.19,1.6-2.81,2.85-6,2.85H246c-3.16,0-5.78-1.25-6-2.85l-2.19-18-.19-1.58-.08-.66-.2-1.58-.08-.66-.19-1.58-.14-1.12c-.11-.91,1.31-1.67,3.1-1.67h23.29C265.1,647.68,266.52,648.44,266.41,649.35Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#65617d"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "212.16 614.76 211.97 616.34 183.15 616.34 182.96 614.76 212.16 614.76",
    fill: "#9d9cb5"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "211.89 617 211.7 618.58 183.43 618.58 183.23 617 211.89 617",
    fill: "#9d9cb5"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "211.62 619.24 211.42 620.82 183.7 620.82 183.51 619.24 211.62 619.24",
    fill: "#9d9cb5"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.67,618s-3.42,15.92,11.79,17.8l.94-1.77S1083.61,622.94,1082.67,618Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.24,633.9l-3.54.75-.35.08s-9.44-7.66-9.32-24.76a42.22,42.22,0,0,0,4.51,7.13C1095.28,622.05,1099.53,628.65,1100.24,633.9Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.43,635.54a2.22,2.22,0,0,1-1.9.25c-9.08-2.12-6-31.71-6-31.71.5.23,1,4,3.14,8.86C1100.32,621.47,1104.35,633.4,1101.43,635.54Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.57,618s.59,15.92-14.62,17.8L1106,634S1120.63,622.94,1121.57,618Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.21,610c.12,17.1-12.14,24.76-12.14,24.76l-.36-.08-3.53-.75c.7-5.25,5-11.85,8.69-16.8A38.47,38.47,0,0,1,1117.21,610Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.66,634a5.52,5.52,0,0,1-2,1.55h0a3.89,3.89,0,0,1-.75.25c-2.23.52-3-1.09-2.88-3.83.21-4.87,3.27-13.32,6-19.65a24.56,24.56,0,0,1,5.7-8.23S1110.59,627.12,1104.66,634Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.12,593.7s-10.14,36-1.41,41.38S1104.36,596.88,1102.12,593.7Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.67,618s-3.42,15.92,11.79,17.8l.94-1.77S1083.61,622.94,1082.67,618Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.24,633.9l-3.54.75-.35.08s-9.44-7.66-9.32-24.76a42.22,42.22,0,0,0,4.51,7.13C1095.28,622.05,1099.53,628.65,1100.24,633.9Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.43,635.54a2.22,2.22,0,0,1-1.9.25c-9.08-2.12-6-31.71-6-31.71.5.23,1,4,3.14,8.86C1100.32,621.47,1104.35,633.4,1101.43,635.54Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.57,618s.59,15.92-14.62,17.8L1106,634S1120.63,622.94,1121.57,618Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.21,610c.12,17.1-12.14,24.76-12.14,24.76l-.36-.08-3.53-.75c.7-5.25,5-11.85,8.69-16.8A38.47,38.47,0,0,1,1117.21,610Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.66,634a5.52,5.52,0,0,1-2,1.55h0a3.89,3.89,0,0,1-.75.25c-2.23.52-3-1.09-2.88-3.83.21-4.87,3.27-13.32,6-19.65a24.56,24.56,0,0,1,5.7-8.23S1110.59,627.12,1104.66,634Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.12,593.7s-10.14,36-1.41,41.38S1104.36,596.88,1102.12,593.7Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.67,618s-2,15.92,13.2,17.8l.94-1.77S1083.61,622.94,1082.67,618Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.65,633.9l-3.54.75-.35.08S1086.91,627.07,1087,610c0,0,2.78,3,5.92,7.13C1096.69,622.05,1100.94,628.65,1101.65,633.9Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.65,633.9l-3.54.75c-3.35-2.94-4.68-10.62-5.16-17.55C1096.69,622.05,1100.94,628.65,1101.65,633.9Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.85,635.54a2.24,2.24,0,0,1-1.91.25c-9.08-2.12-7.42-31.71-7.42-31.71.5.23,2.46,4,4.55,8.86C1101.74,621.47,1105.76,633.4,1102.85,635.54Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.57,618s2,15.92-13.2,17.8l-.94-1.77S1120.63,622.94,1121.57,618Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.21,610c.12,17.1-10.73,24.76-10.73,24.76l-.35-.08-3.54-.75c.7-5.25,5-11.85,8.7-16.8C1114.43,613,1117.21,610,1117.21,610Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.29,617.1c-.46,6.46-1.64,13.57-4.51,16.89a5.08,5.08,0,0,1-.65.66l-3.54-.75C1103.29,628.65,1107.55,622.05,1111.29,617.1Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.07,634a5.41,5.41,0,0,1-2,1.55h0a4,4,0,0,1-.74.25c-2.24.52-3-1.09-2.89-3.83.22-4.87,3.28-13.32,6-19.65,2-4.55,3.81-8,4.29-8.23C1110.73,604.08,1112,627.12,1106.07,634Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.85,635.54a2.4,2.4,0,0,1-1.44-.46c-4.27-2.66-4.36-12.64-3.34-22.14C1101.74,621.47,1105.76,633.4,1102.85,635.54Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.07,634c-.49,1.07-1.15,1.63-2,1.55h0a2.69,2.69,0,0,1-1.21-.46,6.46,6.46,0,0,1-2.42-3.12c.22-4.87,3.28-13.32,6-19.65C1107.42,621.09,1107.75,630.39,1106.07,634Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.12,593.7s-8.72,36,0,41.38S1104.36,596.88,1102.12,593.7Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "1064.75 597.61 1028.44 597.61 1028.44 603.62 1033.98 603.62 1034.12 604.33 1036.34 616 1057.45 616 1059.67 604.33 1059.8 603.62 1064.75 603.62 1064.75 597.61",
    fill: "#4b4770"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "1064.75 597.61 1028.44 597.61 1028.44 603.62 1033.98 603.62 1034.12 604.33 1036.34 616 1057.45 616 1059.67 604.33 1059.8 603.62 1064.75 603.62 1064.75 597.61",
    opacity: 0.1
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "1061.69 601.14 1061.08 604.33 1058.86 616 1037.75 616 1035.53 604.33 1034.92 601.14 1061.69 601.14",
    fill: "#4b4770"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "1061.69 601.14 1061.08 604.33 1035.53 604.33 1034.92 601.14 1061.69 601.14",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1029.85,
    y: 597.61,
    width: 36.31,
    height: 6.01,
    fill: "#4b4770"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5,736.16a17.44,17.44,0,0,0-2.28,4.3c-.14.37-.28.8-.42,1.21a4.36,4.36,0,0,0-.79-.28,11,11,0,0,0-3.57-.3c0-.47.06-1,.07-1.47.15-5.27-.47-12.61-5.5-9.5-4.82,3-1.38,8,1.73,11.2.27.28.54.54.8.79-2.84,2-3.38,6.73-3.85,11.64s-4.64,10.28-7.41,13.33c-.28.31-.53.59-.78.85a10.15,10.15,0,0,0-8.05-2.07c-.11-.43-.24-.88-.37-1.35-2.24-8.09-6.89-22.1-12.82-25.17l.78-1c2.52-3.29,5.36-8.19,1.17-9.44s-4.57,4.24-4.34,8.36q.06.78.12,1.47a6.13,6.13,0,0,0-4.38,2.14l-.65-.77c-3.4-4-9.63-10.37-11.52-5.56-1.76,4.48,3.73,10.3,7.59,13.67l.24.21c-2.59,10.51,8.72,19.08,14.81,22.83l.79.48c-8.4,9.9-13.59,28.46-13.59,28.46l23.52,4.2s15.6-13.46,13.6-26.1l.16,0c15.59-3.12,19.13-19.74,16.7-29.61l.28-.11a17.65,17.65,0,0,0,7.22-5.46C207.12,737.06,198,730.22,193.5,736.16Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5,736.16a17.44,17.44,0,0,0-2.28,4.3c-.14.37-.28.8-.42,1.21a4.36,4.36,0,0,0-.79-.28,11,11,0,0,0-3.57-.3c0-.47.06-1,.07-1.47.15-5.27-.47-12.61-5.5-9.5-4.82,3-1.38,8,1.73,11.2.27.28.54.54.8.79-2.84,2-3.38,6.73-3.85,11.64s-4.64,10.28-7.41,13.33c-.28.31-.53.59-.78.85a10.15,10.15,0,0,0-8.05-2.07c-.11-.43-.24-.88-.37-1.35-2.24-8.09-6.89-22.1-12.82-25.17l.78-1c2.52-3.29,5.36-8.19,1.17-9.44s-4.57,4.24-4.34,8.36q.06.78.12,1.47a6.13,6.13,0,0,0-4.38,2.14l-.65-.77c-3.4-4-9.63-10.37-11.52-5.56-1.76,4.48,3.73,10.3,7.59,13.67l.24.21c-2.59,10.51,8.72,19.08,14.81,22.83l.79.48c-8.4,9.9-13.59,28.46-13.59,28.46l23.52,4.2s15.6-13.46,13.6-26.1l.16,0c15.59-3.12,19.13-19.74,16.7-29.61l.28-.11a17.65,17.65,0,0,0,7.22-5.46C207.12,737.06,198,730.22,193.5,736.16Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M146.68,743l-2.75,8s-1.53-1.08-3.46-2.78c-3.86-3.37-9.35-9.19-7.59-13.67,1.89-4.81,8.12,1.54,11.52,5.56C145.77,741.71,146.68,743,146.68,743Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M152.48,738.35a38.1,38.1,0,0,1-2.68,3.16,42.2,42.2,0,0,1-.49-4.24c-.23-4.12.21-9.59,4.34-8.36S155,735.06,152.48,738.35Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M188,739.62c-.08,2.65-.34,4.77-.34,4.77a34.92,34.92,0,0,1-3.43-3.07c-3.11-3.23-6.55-8.21-1.73-11.2C187.48,727,188.1,734.35,188,739.62Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M204.2,743.09a17.65,17.65,0,0,1-7.22,5.46,21.62,21.62,0,0,1-2.42.88l-3.24-4.55a32.17,32.17,0,0,1,1.34-4.42,17.44,17.44,0,0,1,2.28-4.3C199.42,730.22,208.56,737.06,204.2,743.09Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M144.4,740.11c1.37,1.6,2.28,2.84,2.28,2.84l-2.75,8s-1.53-1.08-3.46-2.78a15.7,15.7,0,0,1,3.1-7.07C143.84,740.77,144.13,740.43,144.4,740.11Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M152.48,738.35a38.1,38.1,0,0,1-2.68,3.16,42.2,42.2,0,0,1-.49-4.24A5.53,5.53,0,0,1,152.48,738.35Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M166,770.31l-6.84,3s-1.49-.72-3.64-2.06c-7.19-4.42-21.64-15.55-12-28.67s17.77,10.41,21,21.92C165.49,768,166,770.31,166,770.31Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M184.18,741.32a5.62,5.62,0,0,1,3.77-1.7c-.08,2.65-.34,4.77-.34,4.77A34.92,34.92,0,0,1,184.18,741.32Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M197,748.55a21.62,21.62,0,0,1-2.42.88l-3.24-4.55a32.17,32.17,0,0,1,1.34-4.42C194.75,741.68,196.29,744.72,197,748.55Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M180,778.27c-.37.08-.76.15-1.15.21-22.93,3.48-7.56-8.89-7.56-8.89s1-1,2.43-2.51c2.77-3.05,6.93-8.39,7.41-13.33.72-7.43,1.55-14.4,10.32-12.36C200.06,743.41,201.71,773.92,180,778.27Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 81.65,
    y: 799.65,
    width: 43.81,
    height: 11.52,
    fill: "#d4dfec"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.69,
    y: 762.21,
    width: 57.24,
    height: 40.2,
    fill: "#d4dfec"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81.65,
    y: 799.65,
    width: 43.81,
    height: 11.52,
    opacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74.69,
    y: 762.21,
    width: 57.24,
    height: 40.2,
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84.53,
    y: 799.65,
    width: 43.81,
    height: 11.52,
    fill: "#d4dfec"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M164.52,764.51c1,3.44,1.48,5.8,1.48,5.8l-6.84,3s-1.49-.72-3.64-2.06C158.2,767.86,161.22,765.3,164.52,764.51Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M180,778.27c-.37.08-.76.15-1.15.21-22.93,3.48-7.56-8.89-7.56-8.89s1-1,2.43-2.51C178,770.51,179.77,774.37,180,778.27Z",
    transform: "translate(-54.11 -35.71)",
    opacity: 0.1
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M142.72,800.2s12.84-46,30.85-31.81-7.33,36-7.33,36Z",
    transform: "translate(-54.11 -35.71)",
    fill: "#009ddd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.09,
    cy: 714.08,
    r: 1.44,
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.97,
    cy: 720.8,
    r: 1.44,
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.74,
    cy: 715.4,
    r: 1.44,
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.14,
    cy: 749.85,
    r: 1.44,
    opacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.74,
    cy: 726.56,
    r: 1.44,
    opacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.86,
    cy: 741.45,
    r: 1.44,
    opacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.01,
    cy: 716.96,
    r: 1.44,
    opacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.78,
    cy: 719.72,
    r: 1.44,
    opacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.86,
    cy: 730.88,
    r: 1.44,
    opacity: 0.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.74,
    cy: 748.77,
    r: 1.44,
    opacity: 0.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.62,
    cy: 741.69,
    r: 1.44,
    opacity: 0.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.17,
    cy: 725.72,
    r: 1.44,
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 84.53,
    y: 799.65,
    width: 43.81,
    height: 4.21,
    opacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 77.57,
    y: 762.21,
    width: 57.24,
    height: 40.2,
    fill: "#d4dfec"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.66,
    cy: 755.25,
    r: 1.44,
    opacity: 0.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.02,
    cy: 757.05,
    r: 1.44,
    opacity: 0.1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 52,
    r: 10.46,
    fill: "#009ddd",
    opacity: 0.1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1054.57,
    cy: 381.09,
    r: 14,
    fill: "#009ddd",
    opacity: 0.1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 1081.56,
    cy: 351.09,
    r: 10.22,
    fill: "#009ddd",
    opacity: 0.1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 14,
    r: 14,
    fill: "#009ddd",
    opacity: 0.1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 78,
    r: 14,
    fill: "#009ddd",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversettlements);
export default __webpack_public_path__ + "static/media/driversettlements.b6c9027569b3177718cb71c02c3abe96.svg";
export { ForwardRef as ReactComponent };